export default "__VITE_ASSET__92tMH_KJ__"